import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ContactTypeService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/contactTypes`, options);
  }
}

export default ContactTypeService;
